module.exports = __webpack_public_path__ + "img/Camera4.3241e492.png";